import React from 'react';
import PropTypes from 'prop-types';

import Button from 'react-bootstrap/lib/Button';

import './styles.css';

const KVButton = ({ kvType, kvIcon, children, disabled, size, ...props }) => {
  const className = size ? `${size} kv-button` : 'kv-button';
  return !kvIcon ? (
    <Button
      bsClass={className}
      bsStyle={kvType}
      children={children}
      disabled={disabled}
      {...props}
    />
  ) : (
    <Button bsClass={className} bsStyle={kvType} {...props}>
      <div className="kv-button-icon-wrapper">
        <i className={`fa ${kvIcon}`} aria-hidden="true" />
        <span>{children}</span>
      </div>
    </Button>
  );
};

KVButton.propTypes = {
  kvType: PropTypes.oneOf([
    'primary',
    'secondary',
    'cancel',
    'danger',
    'filter',
    'success',
    'validate'
  ]),
  kvIcon: PropTypes.string,
  children: PropTypes.any,
  size: PropTypes.oneOf(['small', 'large', 'extra-large', 'auto'])
};

export default KVButton;
